<script setup lang="ts">
useSeoMeta({
  title: "Política de Privacidad · Selectalent Formaciones",
  description:
    "Política de privacidad y tratamiento de datos personales de Selectalent Formaciones.",
  ogTitle: "Política de Privacidad · Selectalent Formaciones",
  ogDescription:
    "Política de privacidad y tratamiento de datos personales de Selectalent Formaciones.",
  twitterCard: "summary_large_image",
});
</script>

<template>
  <main>
    <section class="mx-auto max-w-3xl px-6 py-12 md:py-16">
      <!-- Encabezado -->
      <header class="mb-10">
        <h1
          class="font-poppins text-3xl md:text-5xl font-black leading-tight text-softblack"
        >
          POLÍTICA DE PRIVACIDAD
        </h1>
        <p class="mt-3 font-opensans text-sm text-neutral-600">
          Última modificación: 10 de marzo de 2019
        </p>
      </header>

      <!-- Responsable -->
      <article class="space-y-4">
        <h2 class="font-poppins text-xl md:text-2xl font-black text-softblack">
          Responsable del tratamiento de los datos personales:
        </h2>
        <p class="font-opensans text-[16px] leading-8 text-neutral-800">
          Selectalent Formaciones
        </p>
        <p class="font-opensans text-[16px] leading-8 text-neutral-800">
          Domicilio:<br />
          C/ Julian Camarillo ,29, Edificio D2, 2°D. 28027 Madrid, España
        </p>
        <p class="font-opensans text-[16px] leading-8 text-neutral-800">
          Contacto para la Protección de Datos:<br />
          contact@selectalent-formaciones.es
        </p>
      </article>

      <div class="my-10 h-px w-full bg-neutral-200"></div>

      <!-- Información que es recogida -->
      <article class="space-y-4">
        <h2 class="font-poppins text-xl md:text-2xl font-black text-softblack">
          Información que es recogida
        </h2>
        <p class="font-opensans text-[16px] leading-8 text-neutral-800">
          Nuestro sitio web podrá recoger información personal por ejemplo:
          Nombre, información de contacto como su teléfono, dirección de correo
          electrónica e información demográfica. Así mismo cuando sea necesario
          podrá ser requerida información específica para procesar algún pedido
          o realizar una entrega o facturación.
        </p>
      </article>

      <div class="my-10 h-px w-full bg-neutral-200"></div>

      <!-- Fines de la información recogida -->
      <article class="space-y-4">
        <h2 class="font-poppins text-xl md:text-2xl font-black text-softblack">
          Fines de la información recogida
        </h2>
        <p class="font-opensans text-[16px] leading-8 text-neutral-800">
          Sus datos serán tratados por Selectalent Formaciones para:
        </p>
        <ul
          class="list-disc pl-6 font-opensans text-[16px] leading-8 text-neutral-800 space-y-2"
        >
          <li>
            Gestión de consultas, quejas/incidencias reclamaciones y solicitudes
            realizadas por parte del usuario.
          </li>
          <li>
            Control informático de la página web. Selectalent Formaciones
            realizará aquellas actuaciones de vigilancia y control del uso de la
            página web con el fin de prevenir y detectar cualquier utilización
            fraudulenta (como manipulaciones técnicas, modificaciones de
            código…), con el fin de evitar, prevenir y/o detectar cualquier
            acceso no autorizado, alteración o pérdida de aquella información
            relativa a terceras personas diferentes al usuario que pueda generar
            para Selectalent Formaciones responsabilidades civiles, penales y/o
            administrativas.
          </li>
          <li>
            Analisis de trafico web. Con el objetivo de mejorar el uso de
            nuestra pagina web se pueden recoger datos específicos para análisis
            de trafico web.
          </li>
          <li>
            Comunicaciones comerciales. Si usted nos da su consentimiento,
            Selectalent Formaciones podrá remitirle comunicaciones sobre
            eventos, cursos, informes, colaboraciones y servicios de Selectalent
            Formaciones.
          </li>
        </ul>
      </article>

      <div class="my-10 h-px w-full bg-neutral-200"></div>

      <!-- Tiempo de retención -->
      <article class="space-y-4">
        <h2 class="font-poppins text-xl md:text-2xl font-black text-softblack">
          Tiempo de retención de la información
        </h2>
        <p class="font-opensans text-[16px] leading-8 text-neutral-800">
          Selectalent Formaciones tratará sus datos durante el tiempo necesario
          para la atención de la solicitud requerida por el cliente. En este
          sentido mantendremos bloqueados sus datos personales durante el plazo
          de prescripción de las acciones que pudieran derivarse de la relación
          mantenida con el interesado o para la atención de requerimientos de
          autoridades públicas.
        </p>
      </article>

      <div class="my-10 h-px w-full bg-neutral-200"></div>

      <!-- Comunicación de la información -->
      <article class="space-y-4">
        <h2 class="font-poppins text-xl md:text-2xl font-black text-softblack">
          Comunicación de la información
        </h2>
        <p class="font-opensans text-[16px] leading-8 text-neutral-800">
          No se cederán datos a terceros, salvo requerimiento por parte de
          organismos públicos.
        </p>
        <p class="font-opensans text-[16px] leading-8 text-neutral-800">
          Para poder gestionar debidamente el servicio prestado y los datos
          personales de sus usuarios, Selectalent Formaciones contará con la
          colaboración de terceros proveedores de servicios que pueden tener
          acceso a sus datos personales y que tratarán los referidos datos en
          nombre y por cuenta de Selectalent Formaciones como consecuencia de su
          prestación de servicios. Selectalent Formaciones se compromete a
          suscribir con ellos el correspondiente contrato de tratamiento de
          datos, mediante el cual les impondrá, entre otras, las siguientes
          obligaciones: aplicar medidas técnicas y organizativas apropiadas;
          tratar los datos personales para las finalidades pactadas y atendiendo
          únicamente a las instrucciones documentadas de Selectalent
          Formaciones; y suprimir o devolver los datos a Selectalent Formaciones
          una vez finalice la prestación de los servicios.
        </p>
      </article>

      <div class="my-10 h-px w-full bg-neutral-200"></div>

      <!-- Derechos de los usuarios -->
      <article class="space-y-4">
        <h2 class="font-poppins text-xl md:text-2xl font-black text-softblack">
          Los derechos de los usuarios
        </h2>
        <p class="font-opensans text-[16px] leading-8 text-neutral-800">
          Usted tiene derecho a obtener confirmación sobre si en Selectalent
          Formaciones estamos tratando datos personales que le conciernen, o no,
          y en tal caso, a acceder a sus datos personales, así como a solicitar
          la rectificación de los datos inexactos o, en su caso, solicitar su
          supresión cuando, entre otros motivos, los datos ya no sean necesarios
          para los fines que fueron recogidos.
        </p>
        <p class="font-opensans text-[16px] leading-8 text-neutral-800">
          En determinadas circunstancias, usted podrá solicitar la limitación
          del tratamiento de sus datos, en cuyo caso únicamente los
          conservaremos para el ejercicio o la defensa de reclamaciones.
        </p>
        <p class="font-opensans text-[16px] leading-8 text-neutral-800">
          Usted podrá solicitar la portabilidad de sus datos para que éstos sean
          remitidos directamente a la entidad por él designada en un formato
          estructurado, de uso común y lectura mecánica. Usted puede desde este
          momento y en cualquier otro posterior retirar el consentimiento
          otorgado para el tratamiento. Si usted quiere interponer una
          reclamación sobre el tratamiento de sus datos, podrá dirigirse al
          Delegado de Protección de Datos de Selectalent Formaciones.
        </p>
        <p class="font-opensans text-[16px] leading-8 text-neutral-800">
          Para el ejercicio de los derechos mencionados en este apartado usted
          puede dirigirse, mediante escrito al Delegado de Protección de Datos
          de Selectalent Formaciones, acreditando su identidad (DNI), mediante
          correo electrónico a: contact@selectalent-formaciones.es
        </p>
        <p class="font-opensans text-[16px] leading-8 text-neutral-800">
          Usted podrá reclamar ante la Agencia Española de Protección de Datos
          (Autoridad de Control competente en esta materia), especialmente
          cuando no haya obtenido satisfacción en el ejercicio de sus derechos,
          mediante escrito dirigido a la misma, C/ Jorge Juan, número 6, 28001 –
          Madrid o a través de la web: https://www.agpd.es
        </p>
      </article>

      <div class="mt-12">
        <p class="font-opensans text-sm text-neutral-600">
          © Selectalent Formaciones
        </p>
      </div>
    </section>
  </main>
</template>
